/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'fund-aba-routing',
  template: require('./fund-aba-routing.component.html')
})

export class FundAbaRoutingComponent extends BaseRoute {

  constructor(injector: Injector) {
    super(injector);
  }

  btnClick(e) {
    this.router.navigate(['verify-ach-profile-passed']);
  }
}